<div class="container">
  <div class="modal">
    <div class="modal__content">
      <span><ion-spinner name="lines"></ion-spinner></span>
      <span *ngIf="content$ | async as c" class="font-bold">{{c}}</span>
    </div>
  </div>
</div>